import React from 'react';
const STATS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '1 + 5',
  label: 'System & Bonuses'
}, {
  value: 'Pro',
  label: 'Professional Level'
}, {
  value: '100%',
  label: 'Digital Access'
}];
export function Stats() {
  return <section aria-label="Key numbers" className="w-full bg-brand px-4 py-5" data-id="element-208" data-mp="2ixpcquhq171w">
      <div className="mx-auto max-w-4xl" data-id="element-209" data-mp="2nvqsb5fxuo8m">
        <p className="text-center font-head text-[10px] font-semibold uppercase tracking-[0.14em] text-mustard sm:text-xs" data-id="element-210" data-mp="2nyv2qkjzyg7q">
          Built for Spanish teachers who want everything in one place
        </p>
        <dl className="mt-2.5 grid grid-cols-2 gap-x-2 gap-y-2.5 lg:grid-cols-4" data-id="element-211" data-mp="207g16u01o2xj">
          {STATS.map(stat => <div key={stat.label} className="text-center" data-id="element-212" data-mp="256kadkmyy0nv">
              <dt className="sr-only" data-id="element-213" data-mp="2572f75np5n7e">{stat.label}</dt>
              <dd className="font-head text-2xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-214" data-mp="1q8rv8tlc3ea7">
                {stat.value}
              </dd>
              <p className="mt-0.5 text-[9px] font-semibold uppercase tracking-widest text-white/70 sm:text-[10px]" data-id="element-215" data-mp="1vah6oacgxtyt">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}